var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"math-render"},[_c('div',{staticClass:"mathview",attrs:{"id":_vm.mathview}}),(_vm.imgshow && !_vm.value)?_c('span',{staticClass:"placeholder"},[_vm._v("请输入答案")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }